import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    bigType: '销量'
  },
  getters: {
  },
  actions: {
    setBigType({ commit }, val) {
      commit('SET_BIG_TYPE', val);
    },
  },
  mutations: {
    SET_BIG_TYPE(state, val) {
      state.bigType = val;
    },
  },
});


// WEBPACK FOOTER //
// ./src/store/index.js